import { createContext, type ReactNode } from 'react';

interface ContentHeaderContextType {
  headerActions: ReactNode;
  setHeaderActions: (actions: ReactNode) => void;
}

export const ContentHeaderContext = createContext<
  ContentHeaderContextType | undefined
>(undefined);
